/**
 * ChangePasswordModal.tsx
 */
/** @jsxImportSource @emotion/react */
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, IconButton, MenuItem, Select } from "@mui/material";
import { Dispatch, SetStateAction, VFC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AvailLanguage } from "src/utils/getBrowserLanguage";

interface Props {
  lang: string;
  open: boolean;
  setLang: Dispatch<SetStateAction<AvailLanguage>>;
  handleClose: () => void;
}
const ChangePasswordModal: VFC<Props> = (props: Props) => {
  const [t, i18n] = useTranslation();

  useEffect(() => {
    if (props.lang) {
      i18n.changeLanguage(props.lang);
    } else {
      i18n.changeLanguage("en");
    }
  }, [i18n, props.lang]);

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      maxWidth="xs"
      fullWidth
    >
      <div className="p-8">
        <div className="flex justify-between items-center">
          <span className="text text-lg font-bold">
            {t("modal.change_password.title")}
          </span>
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="flex items-center p-4 pt-2">
          <Select
            className="w-full"
            value={props.lang}
            onChange={(e) => {
              props.setLang(e.target.value as AvailLanguage);
              localStorage.setItem(
                "vritimes_language",
                e.target.value as AvailLanguage
              );
            }}
          >
            <MenuItem disabled={props.lang === "en"} value="en">
              English
            </MenuItem>
            <MenuItem disabled={props.lang === "id"} value="id">
              Indonesian
            </MenuItem>
            <MenuItem disabled={props.lang === "jp"} value="jp">
              Japanese
            </MenuItem>
            <MenuItem disabled={props.lang === "vn"} value="vn">
              Vietnamese
            </MenuItem>
            <MenuItem disabled={props.lang === "th"} value="th">
              Thai
            </MenuItem>
          </Select>
        </div>
      </div>
    </Dialog>
  );
};

export default ChangePasswordModal;
